import { usePhase } from '../../utils/usePhase'
import { useIsFirstPhase } from '../../utils/useIsFirstPhase'
import {
  GreyGrey50,
  GreyGrey90,
  IconCircleInfo,
  IndigoIndigo60,
  Link,
  Popover,
  Primary13Regular,
  Primary13SemiBold,
  SwitchLineInput,
  Box,
  Flex
} from '@sequencehq/core-components'

export const PhaseRecurrencePreferenceField = (props: { phaseId: string }) => {
  const { phase, updatePhase } = usePhase(props.phaseId)
  const isFirstPhase = useIsFirstPhase(props.phaseId)

  if (isFirstPhase) {
    return null
  }

  return (
    <Flex
      {...Primary13Regular}
      color={GreyGrey90}
      gap="8px"
      alignItems="center"
      height="100%"
    >
      <SwitchLineInput
        data-testid={`reviewPricing.phase.${phase.id}.recurrencePreference`}
        value={phase.recurrencePreference === 'RESET'}
        onChange={newValue =>
          updatePhase({
            recurrencePreference: newValue
              ? 'RESET'
              : 'CONTINUE_FROM_PREVIOUS_PHASE'
          })
        }
        text={'Reset billing period'}
      />
      <Popover
        content={
          <Box>
            <Box {...Primary13SemiBold} color={GreyGrey90} marginBottom="8px">
              Reset billing period
            </Box>
            <Box {...Primary13Regular} color={GreyGrey90}>
              Enable this to start new billing periods for all prices from here.
              Otherwise, existing billing periods will continue as before.
              <Link
                to="https://docs.sequencehq.com/billing/billing-schedule-phases#reset-billing-periods"
                isExternal
                color={IndigoIndigo60}
                marginLeft="4px"
              >
                Learn more
              </Link>
            </Box>
          </Box>
        }
      >
        <IconCircleInfo color={GreyGrey50} />
      </Popover>
    </Flex>
  )
}
